var clientValidatePasswordMapper = function (response) {
    if (response) {
        return {
            isOtpSucesss: true,
            loginFlow: response.loginFlow,
            message: response.msg,
            status: response.sts,
        };
    }
    return {};
};
export default clientValidatePasswordMapper;
